import React from "react";
import Link from "next/link";
import Image from "next/image";
import Remote, { Blur } from "./LoaderRemote";
import Local from "./ImageLoader";
import FavBtn from "./FavBtn";
import DefaultCurrencyFormat from "./DefaultCurrencyFormat";
import styles from "./VillaItem.module.css";
import { useTranslation } from "../context/TranslationContext";
import { toIsoDate } from "../helper/date";
//import Lottie from "lottie-react";
//import animation from "../animations/maximize.json";

const Price = ({ text, price, price2, night }) => {
  const { nightly } = useTranslation();
  return (
    <>
      <div className="flex flex-col items-center">
        <span className="text-xl font-semibold text-brand-color-secondary">
          {price}{" "}
          {!night && (
            <small className="text-sm text-black -top-0.5 relative">
              /{nightly}
            </small>
          )}
        </span>
        {text && (
          <span className="inline-block text-sm font-semibold opacity-30">
            {text}
          </span>
        )}
      </div>
    </>
  );
};

const VillaItem = ({ data, className, lastMinute, shortTerm, index }) => {
  const {
    viewDetailUpper,
    nightUpper,
    person,
    bedRoom,
    bathRoom,
    villaItemPrice,
    villaItemPriceNightly,
    lastMinuteBadge,
    nights,
    discountedBadge,
    instantBooking,
  } = useTranslation();
  const style = {
    height: 32,
    width: 32,
  };

  if (data.isSonDakika == "1" || shortTerm == 1) {
    lastMinute = 1;
  }

  // Listeleme sayfasında (tarihsiz arama) API her villanın altına sonDakika nesnesi döndürür
  const sonDakika = data?.sonDakika ? data.sonDakika : null;
  const sonDakikaStart = sonDakika ? toIsoDate(sonDakika.tarih1) : "";
  const sonDakikaEnd = sonDakika ? toIsoDate(sonDakika.tarih2) : "";
  // URL zaten tarihli geliyorsa (son dakika sayfası / anasayfa) tekrar tarih ekleme
  const sonDakikaUrl =
    sonDakikaStart && sonDakikaEnd && !data.url.includes("start=")
      ? data.url +
        (data.url.includes("?") ? "&" : "?") +
        "start=" +
        sonDakikaStart +
        "&end=" +
        sonDakikaEnd
      : data.url;

  // Tarihsiz listelerde: en düşük gecelik fiyat indirimliyse eski fiyatı da göster
  const minfiyatIndirimli =
    !data.geceFark &&
    parseInt(data?.minfiyatIndirimsiz) > parseInt(data?.minfiyat);

  return (
    <div className={"flex flex-col relative " + (className ? className : "")}>
      <Link href={data.url}>
        <a title={data.title} className="relative h-52 lg:h-72 group">
          <div className="relative w-full h-full overflow-hidden">
            {data.image && (
              <Image
                src={data.image}
                layout={"fill"}
                loader={Remote}
                alt={data.title}
                objectFit={"cover"}
                sizes="(max-width: 425px) 70vw,(max-width: 768px) 30vw,
              (max-width: 1200px) 50vw,
              33vw"
                placeholder="blur"
                blurDataURL={Blur(data.image)}
                priority={index == 0}
              />
            )}
            {/* Kuşak */}
            {data?.IndirimTutari > 0 ||
            (!lastMinute && !sonDakika && minfiyatIndirimli) ? (
              <div className="absolute top-0 left-0 px-4 py-1 text-sm font-bold text-white bg-red-500 rounded-br-lg animate-slide-in">
                {discountedBadge}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="absolute bottom-0 left-0 items-center justify-center hidden w-full transition-all lg:flex bg-villa-item transform-gpu h-2/3 group-hover:h-full group-hover:bg-villa-item2">
            <span className="px-6 py-5 text-sm font-bold leading-5 text-white border opacity-0 group-hover:opacity-100">
              {viewDetailUpper}
            </span>
          </div>
          {data.ribbon && (
            <div
              className={`absolute text-white font-bold text-sm bottom-2 ${
                styles.Ribbon
              }  ${lastMinute ? "left-6" : "left-2 lg:left-auto lg:right-2"}`}
            >
              {data.ribbon}
            </div>
          )}
        </a>
      </Link>
      {sonDakika && (
        <Link href={sonDakikaUrl}>
          <a
            title={data.title}
            className="absolute top-0 left-0 z-10 overflow-hidden rounded-br-lg shadow-md group animate-slide-in"
          >
            <div
              className={
                "relative flex items-center gap-1 py-1 pl-2 pr-3 font-bold text-white text-xxs tracking-1 " +
                styles.SonDakikaBadge
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-3 h-3 shrink-0"
              >
                <path
                  fillRule="evenodd"
                  d="M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z"
                  clipRule="evenodd"
                />
              </svg>
              {lastMinuteBadge}
            </div>
            <div className="flex flex-col px-2 py-1.5 leading-tight bg-white bg-opacity-95">
              <span className="font-semibold text-brand-black text-[11px]">
                {sonDakika.gun1} - {sonDakika.gun2}
                <span className="ml-1 opacity-50">
                  {sonDakika.gece} {nights}
                </span>
              </span>
              <span className="flex items-baseline gap-1.5">
                {parseInt(sonDakika.eskiFiyat) > 0 && (
                  <span className="text-[11px] font-semibold text-red-600 line-through opacity-80">
                    <DefaultCurrencyFormat
                      value={parseInt(sonDakika.eskiFiyat)}
                      Symbol={sonDakika.Symbol || data.Symbol}
                    />
                  </span>
                )}
                <span className="text-sm font-bold text-[#E01252] group-hover:underline">
                  <DefaultCurrencyFormat
                    value={parseInt(sonDakika.fiyat)}
                    Symbol={sonDakika.Symbol || data.Symbol}
                  />
                </span>
              </span>
            </div>
          </a>
        </Link>
      )}
      {data?.BookableDirectly == "1" && (
        <div className="group absolute top-1 right-12 flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-yellow-100 text-yellow-600 shadow-sm transition-all duration-300 hover:w-44 hover:justify-start hover:px-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-5 w-5 shrink-0 animate-pulse"
          >
            <path
              fillRule="evenodd"
              d="M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z"
              clipRule="evenodd"
            />
          </svg>
          <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs font-bold opacity-0 transition-all duration-300 group-hover:ml-2 group-hover:max-w-[150px] group-hover:opacity-100">
            {instantBooking}
          </span>
        </div>
      )}
      <FavBtn
        hideText={true}
        className={"absolute top-0 right-0 flex flex-col "}
        inlineclass="w-10 h-10 p-2.5 bg-white bg-opacity-90 transition-colors  rounded-bl-lg "
        data={{
          id: data.id,
          baslik: data.name,
          destination: data.destination,
          url: data.url,
          image: data.image,
        }}
      />
      <div
        className={"flex flex-col " + (lastMinute ? "bg-white" : "ListVillaBg")}
      >
        <div className="flex justify-between px-2 py-5 border-b ml:px-5 lg:px-7 border-brand-gray-7">
          <div className="flex flex-col">
            <strong className="text-brand-black lg:text-xl">{data.name}</strong>
            <div className="flex mt-1 lg:mt-0">
              <Image
                src={"/icons/villaLocationIcon.svg"}
                width={16}
                height={18}
                alt={"Villa Location Icon"}
                className="iconsImgFilter"
              />
              <span className="ml-2 font-bold opacity-50 text-13 lg:text-sm">
                {data.destination}
              </span>
            </div>
          </div>

          <div className="flex flex-col items-end text-right ">
            {lastMinute ? (
              <div className="flex flex-col-reverse items-end -mt-12 sm:items-center sm:mt-0 sm:flex-row">
                <div className="flex flex-col-reverse sm:mr-2 sm:flex-col">
                  <small className="text-xs font-semibold text-black">
                    {data.gun1}-{data.gun2}
                  </small>
                  <div className="flex flex-col items-end sm:items-center">
                    {!shortTerm && parseInt(data?.eskiFiyat) > 0 && (
                      <span className="block text-sm font-semibold text-red-600 line-through sm:text-base">
                        <DefaultCurrencyFormat
                          value={parseInt(data.eskiFiyat)}
                          Symbol={data.Symbol}
                        />
                      </span>
                    )}
                    <div className="text-lg font-bold sm:text-xl text-brand-color-secondary">
                      <DefaultCurrencyFormat
                        value={shortTerm ? data.sqfiyat : data.fiyat}
                        Symbol={data.Symbol}
                      />
                    </div>
                  </div>
                </div>
                <span className="w-12 h-12 z-10 bg-white text-center font-semibold text-brand-gray-2 text-xs px-2 pt-2 rounded-sm border-2 border-[#DFE2E2]">
                  <strong>{shortTerm ? data.geceFark : data.gece}</strong>{" "}
                  {nightUpper}
                </span>
              </div>
            ) : (
              <Price
                night={data.geceFark}
                text={
                  data.geceFark
                    ? data.geceFark + " " + villaItemPriceNightly
                    : villaItemPrice
                }
                price={
                  data.geceFark ? (
                    <>
                      {data?.IndirimTutari > 0 ? (
                        <span className="block text-base text-center text-red-600 line-through">
                          <DefaultCurrencyFormat
                            value={
                              parseInt(data.IndirimTutari) +
                              parseInt(data.sqfiyat)
                            }
                            Symbol={data.Symbol}
                          />
                        </span>
                      ) : (
                        ""
                      )}
                      <DefaultCurrencyFormat
                        value={parseInt(data.sqfiyat)}
                        Symbol={data.Symbol}
                      />
                    </>
                  ) : (
                    <>
                      {minfiyatIndirimli && (
                        <span className="block text-base text-center text-red-600 line-through">
                          <DefaultCurrencyFormat
                            value={parseInt(data.minfiyatIndirimsiz)}
                            Symbol={data.Symbol}
                          />
                        </span>
                      )}
                      <DefaultCurrencyFormat
                        value={parseInt(data.minfiyat)}
                        Symbol={data.Symbol}
                      />
                    </>
                  )
                }
                price2={
                  data.geceFark ? (
                    false
                  ) : (
                    <DefaultCurrencyFormat
                      value={parseInt(data.maxfiyat)}
                      Symbol={data.Symbol}
                    />
                  )
                }
              />
            )}
          </div>
        </div>
        <div className="justify-between hidden px-2 pt-5 pb-7 ml:px-7 lg:flex">
          <div className="flex items-center justify-items-center">
            <Image
              src="/icons/villaItemProp1.svg"
              width="19"
              className="iconsImgFilter"
              height="21"
              alt={person}
              loader={Local}
            />
            <div className="flex flex-col ml-3 text-sm font-bold leading-4 text-black">
              <span>{data.kisi}</span>
              <span>{person}</span>
            </div>
          </div>
          <div className="flex items-center justify-items-center">
            <Image
              src="/icons/villaItemProp2.svg"
              width="19"
              height="21"
              className="iconsImgFilter"
              alt={bedRoom}
              loader={Local}
            />
            <div className="flex flex-col ml-3 text-sm font-bold leading-4 text-black">
              <span>{data.yatak_odasi}</span>
              <span>{bedRoom}</span>
            </div>
          </div>
          <div className="flex items-center justify-items-center">
            <Image
              src="/icons/villaItemProp3.svg"
              width="19"
              className="iconsImgFilter"
              height="21"
              alt={bathRoom}
              loader={Local}
            />
            <div className="flex flex-col ml-3 text-sm font-bold leading-4 text-black">
              <span>{data.banyo}</span>
              <span>{bathRoom}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between px-2 py-3 ml:px-7 lg:hidden">
          <span className="text-sm font-bold text-brand-gray">
            {data.kisi} {person}, {data.yatak_odasi} {bedRoom}, {data.banyo}{" "}
            {bathRoom}
          </span>
          <Link href={data.url}>
            <a title={data.title}>
              {/* <Lottie animationData={animation} style={style} /> */}
              {/* <BsArrowRightSquare size={24}></BsArrowRightSquare> */}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VillaItem;
